import { render, staticRenderFns } from "./BuyerListView.vue?vue&type=template&id=7374c0a7&scoped=true"
import script from "./BuyerListView.vue?vue&type=script&lang=js"
export * from "./BuyerListView.vue?vue&type=script&lang=js"
import style0 from "./BuyerListView.vue?vue&type=style&index=0&id=7374c0a7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7374c0a7",
  null
  
)

export default component.exports